/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import URI from 'urijs';
import { buildColumn } from '@bingads-webui-grid/campaignui-common-columns';
import { getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import { Link } from '@bingads-webui-campaign-react/router';

const defaultColumn = ({
  i18n,
  protectionAssociation,
  exclusionAssociation,
  siteMap,
  scope,
  isBrandProtectionEnabled,
  isBrandExclusionEnabled,
}) => [
  {
    key: 'Name',
    title: i18n.getString(_TL_('List name')),
    helpId: 'pop_BA_BrandLists_ListName',
    onRender: (item) => {
      const {
        values: {
          uid,
          cid,
          aid,
        },
      } = scope;
      const brandListId = item.Id;
      const path = getRoutePathById(siteMap, 'brand-lists-details');
      const uri = new URI(path)
        .addQuery({
          uid,
          cid,
          aid,
          brandListId,
        })
        .toString();
      return (<Link to={uri}>{item.Name}</Link>);
    },
  },
  {
    key: 'Count',
    title: i18n.getString(_TL_('Number of brands')),
    helpId: 'pop_BA_BrandLists_Number',
    onRender: item => `${item.Count}${item.Requested ? ` (${item.Requested} ${i18n.getString(_TL_('requested'))})` : ''}`,
  },
  {
    key: 'CampaignAssociationCount',
    expandProperties: ['CampaignExclusionAssociationCount'],
    title: i18n.getString(_TL_('List applied to campaign')),
    helpId: 'pop_BA_BrandLists_Campaigns',
    onRender: (item) => {
      if (!item.CampaignAssociationCount && !item.CampaignExclusionAssociationCount) {
        return '-';
      }
      return (
        <div>
          {(isBrandProtectionEnabled && item.CampaignAssociationCount) ? (
            <div>
              <span>{i18n.getString(_TL_('Brand protection: '))}</span>
              <a onClick={() => protectionAssociation(item)} role="button" href="#" className="applied-link protection">
                {i18n.getString(_TL_('{{number}} broad match-only campaigns'), {
                  number: item.CampaignAssociationCount,
                })}
              </a>
            </div>
          ) : null}
          {(isBrandExclusionEnabled && item.CampaignExclusionAssociationCount) ? (
            <div>
              <span>{i18n.getString(_TL_('Brand exclusion: '))}</span>
              <a onClick={() => exclusionAssociation(item)} role="button" href="#" className="applied-link exclusion">
                {i18n.getString(_TL_('{{number}} Performance Max campaigns '), {
                  number: item.CampaignExclusionAssociationCount,
                })}
              </a>
            </div>
          ) : null}
        </div>
      );
    },
  },
];


export const buildColumns = ({
  i18n, protectionAssociation, exclusionAssociation, siteMap, scope, isBrandProtectionEnabled, isBrandExclusionEnabled,
}) => {
  const columns = defaultColumn({
    i18n,
    protectionAssociation,
    exclusionAssociation,
    siteMap,
    scope,
    isBrandProtectionEnabled,
    isBrandExclusionEnabled,
  });
  return columns.map(column => ({
    ...buildColumn(column),
    expandProperties: column.expandProperties,
    onRender: column.onRender,
  }));
};
